<template>
<el-dialog class='order-dialog' :title="$t('actions.order.wechat.title')" size="small" @close='close' :visible.sync="dialogVisible">
  <div class='content paid' v-if="paid">
    <p>{{$t('actions.order.paid')}}</p>
  </div>
  <div class='content' v-else-if="payType === 'wxpay'">
    <p>{{$t('actions.order.wechat.hint')}}</p>
    <div class='img qrcode' :style="{'backgroundImage': 'url(//qrcode.ppj.io/'+qrcode+')' }"></div>
  </div>
  <div class='content' v-else-if="payType === 'alipay'">
    <p>请在打开的支付宝页面中完成付款</p>
  </div>
  <div class='content' v-else-if="errorMsg">
    <p>{{errorMsg}}</p>
  </div>
  <div class='content' v-else>
    <p>{{$t('actions.order.loading')}}</p>
    <spinner class="spinner" :size="180" :percentage="80" v-once />
  </div>
  <div class='footer' slot='footer'>
    <p>
      <a class='link' @click="$contactCS" target='_blank'>遇到问题？</a>
    </p>
  </div>
</el-dialog>
</template>

<script>
export default {
  data() {
    return {
      qrcode: null,
      order: null,
      payType: null,
      paid: false,
      success: null,
      error: null,
      dialogVisible: false,
      openWindow: null,
      errorMsg: null
    }
  },
  watch: {
    paid: function(newValue) {
      // 自动关闭
      if (newValue === true) {
        let vm = this
        setTimeout(function() {
          vm.close()
        }, 3000)
      }
    }
  },
  methods: {
    orderPaid() {
      this.paid = true

      if (this.openWindow) {
        this.openWindow.close()
        this.openWindow = null
      }

      if (this.success) {
        if (typeof this.success === 'function') {
          this.success(this.order)
        }
      }
    },
    open(params) {
      let vm = this
      vm.dialogVisible = true

      vm.success = params.success || function() {}
      vm.error = params.error || function() {}

      if (params.payment_method === 'alipay') {
        // 使用弹框来避免open被拦截
        vm.openWindow = window.open('/static/alipay.html')
      }

      // get order config
      vm.$store.dispatch('quota/buy', {
        package: params.package,
        project_id: params.project_id,
        promote_code: params.promote_code,
        payment_method: params.payment_method,
        return_path: '/static/alipay.html?close=true'
      }).then(res => {
        let data = res.data
        vm.order = data.order_id
        vm.payType = data.payment_method

        if (data.paid) {
          vm.orderPaid()
          return
        } else if (data.payment_method === 'wxpay') {
          vm.qrcode = data.payment_params.code_url
        } else if (data.payment_method === 'alipay') {
          vm.openWindow.location.href = data.payment_params.url
        }

        vm.$store.dispatch('order/checkState', vm.order).then(() => {
          vm.orderPaid()
        })
      }).catch(err => {
        // handle error for promote code invalid
        if (vm.openWindow) {
          vm.openWindow.close()
        }

        let data = err.response.data
        if (data.type === 'InvalidPromoteCodeError') {
          if (vm.error && typeof vm.error === 'function') {
            vm.error(data)
          }
          vm.close()
        } else {
          vm.errorMsg = data.message
        }
      })
    },
    close() {
      this.$store.dispatch('order/cancelCheckState', this.order)
      this.qrcode = null
      this.order = null
      this.success = null
      this.payType = null
      this.paid = false
      this.dialogVisible = false
      this.errorMsg = null
      this.openWindow = null
    }
  }
}
</script>

<style lang='scss' scoped>
.order-dialog {
    .content {
        text-align: center;
    }

    .footer {
        text-align: center;
    }

    $qrcode-width: 180px;
    .qrcode {
        width: $qrcode-width;
        height: $qrcode-width;
    }
}
</style>



// WEBPACK FOOTER //
// order.dialog.vue?3910abf1